/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=45f62420&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f62420",
  null
  
)

export default component.exports